"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EmpoweringEducationalExcellence() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="25078" id="grow-your-business-with-smarter-digital-marketing" ref={sectionRef} className="relative w-full overflow-hidden bg-[#F6FAFE] py-20 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16 items-center">
          {}
          <div className={`lg:col-span-6 flex flex-col gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <h1 className="font-sans text-[34px] font-bold leading-[1.1] text-[#000000] tracking-tight">
              Grow Your Business <br />
              With Smarter{" "}
              <span className="relative inline-block">
                Digital Marketing
                {}
                <svg className="absolute -bottom-2 left-0 w-full h-[0.4em] text-[#FF6600] -z-10 pointer-events-none" viewBox="0 0 200 20" preserveAspectRatio="none" fill="currentColor" aria-hidden="true">
                  <path d="M5,15 Q50,5 90,12 T190,8" stroke="currentColor" strokeWidth="8" fill="none" strokeLinecap="round" />
                </svg>
              </span>
            </h1>

            <p className="font-sans text-[14px] leading-relaxed text-[#464646] max-w-xl">
              Fox River Marketing is a strategic digital consultancy helping small and local 
              businesses scale through revenue-driven SEO, visibility, and lead generation. 
              We provide the data-backed direction needed to transform your growth goals 
              into measurable market success.
            </p>

            <div className="pt-4">
              <Button asChild size="lg" className="relative h-14 px-8 text-[14px] font-bold uppercase tracking-wider bg-[#FF6600] text-white rounded-none shadow-md transition-transform hover:scale-105 hover:bg-[#E65C00]">
                <Link to="/ContactPage">
                  <span className="relative z-10 flex items-center gap-2">
                    Schedule a Consultation
                    <ArrowRight className="h-5 w-5" />
                  </span>
                  {}
                  <span className="absolute inset-0 rounded-none bg-[#FF6600] opacity-75 animate-ping duration-[3000ms]" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className={`lg:col-span-6 relative transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="relative aspect-[4/3] w-full overflow-hidden rounded-none shadow-md">
              {}
              <div className="absolute inset-0 bg-[#000000]/5 mix-blend-multiply z-10 pointer-events-none" />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#000000]/10 to-transparent z-10 pointer-events-none" />
              
              <img src="https://foxrivermarketing.net/wp-content/uploads/2026/03/FRMG_Chicago_800x650.jpg" alt="Growth chart overlaying a local business scene representing digital marketing success" className="h-full w-full object-cover transition-transform duration-700 !rounded-md hover:scale-105" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -left-6 -z-10 h-full w-full rounded-none border border-[#FF6600]/20 bg-transparent" />
          </div>
        </div>
      </div>
    </section>;
}